import { render, staticRenderFns } from "./GraficaVolumenesDestinos.vue?vue&type=template&id=1639e6c4"
import script from "./GraficaVolumenesDestinos.vue?vue&type=script&lang=js"
export * from "./GraficaVolumenesDestinos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports